import SesamyNivoTheme from "@/components/Nivo/SesamyNivoTheme";
import Tooltip from "@/components/Nivo/Tooltip";
import dynamic from "next/dynamic";

const ResponsiveRadialBar = dynamic(
  () =>
    import("@nivo/radial-bar").then(
      ({ ResponsiveRadialBar }) => ResponsiveRadialBar,
    ),
  { ssr: false },
);

const transform = (data: [string, number][]) =>
  data
    .map(([key, value]) => ({
      id: key,
      data: [
        {
          x: key,
          y: value,
        },
      ],
    }))
    .sort((a, b) => b.data[0].y - a.data[0].y);

const COLORS = [
  "#C3DF25", // lime,
  "#6EEA92", // olive,
  "#EE7B30", // orange,
  "#F3538B", // crimson,
  "#E9A8E8", // pink,
  "#6CE9FC", // baby,
] as string[];

const RadialBar = ({
  data,
  fullyRendered = () => {},
}: {
  data: [string, number][];
  fullyRendered?: Function;
}) => {
  const totalCount = data
    .map((item) => item[1] as number)
    .reduce((acc, curr) => acc + curr, 0);

  return (
    <div className="row aspect-2/1 w-full">
      {Object.keys(data).length ? (
        <ResponsiveRadialBar
          layers={[
            "grid",
            "tracks",
            "bars",
            "labels",
            "legends",
            () => fullyRendered(),
          ]}
          data={transform(data)}
          theme={SesamyNivoTheme}
          margin={{ top: 0, right: 180, bottom: 0, left: 0 }}
          colors={COLORS}
          valueFormat=">-.2f"
          padding={0.5}
          cornerRadius={15}
          innerRadius={0.15}
          tracksColor="#282834"
          enableRadialGrid={false}
          enableCircularGrid={false}
          startAngle={0}
          endAngle={360}
          radialAxisStart={null}
          maxValue={totalCount}
          circularAxisOuter={null}
          tooltip={({ bar: { category, value, color } }) => (
            <Tooltip className="row-left gap-2">
              <div
                className="h-2 w-2 rounded-full"
                style={{ backgroundColor: color }}
              />
              <span className="text-muted-foreground">{category}</span> {value}
            </Tooltip>
          )}
          legends={[
            {
              anchor: "right",
              direction: "column",
              justify: false,
              translateX: 0,
              translateY: 0,
              itemsSpacing: 6,
              itemDirection: "left-to-right",
              itemWidth: 100,
              itemHeight: 20,
              itemTextColor: "#999",
              symbolSize: 10,
              symbolShape: "circle",
            },
          ]}
        />
      ) : (
        "No data to show"
      )}
    </div>
  );
};

export default RadialBar;
